<template>
    <form class="form-control-line m-t-2" @submit.prevent="onSubmit">
        <div class="card text-white bg-danger" v-if="Object.keys(errors).length">
            <div class="card-header">
                <h4 class="m-b-0 text-white">Validation Errors</h4></div>
            <div class="card-body">
                <p v-if="typeof errors === 'string'" class="card-text">{{errors}}</p>
                <p v-else class="card-text" v-for="(error, key) in errors" :key="key">
                    {{key}}:{{error}}
                </p>
            </div>
        </div>
        <div class="form-body">
            <div class="form-group">
                <label class="custom-control custom-checkbox m-b-0">
                    <input type="checkbox" class="custom-control-input" id="is_active"
                           name="is_active"
                           v-model="user.isActive">
                    <span class="custom-control-label">is Active</span>
                </label>
            </div>
            <div class="form-group">
                <label class="control-label">Username:</label>
                <input type="text" id="username" name="username" v-model="user.username"
                       class="form-control form-control-line"
                       placeholder="Username">
                <div class="text-danger" v-if="$v.user.username.$error">Username is required.</div>
            </div>
            <div class="form-group">
                <label class="control-label">Email:</label>
                <input type="email" id="email" name="email" v-model="user.email"
                       class="form-control"
                       placeholder="email">
                <div v-if="$v.user.email.$error">
                    <div class="text-danger" v-if="!$v.user.email.email">Invalid email.</div>
                    <div class="text-danger" v-if="!$v.user.email.required">Email is required.</div>
                </div>
            </div>
            <div class="form-group">
                <label class="control-label">Profit Rate(%):</label>
                <input type="number" id="rate" name="profitRate" v-model.number="user.profitRate"
                       class="form-control"
                       placeholder="0-100%">
                <div v-if="$v.user.profitRate.$error">
                    <div class="text-danger" v-if="!$v.user.profitRate.between">Must be in 0-100.</div>
                    <div class="text-danger" v-if="!$v.user.profitRate.required">Profit Rate is required.</div>
                </div>
            </div>
            <div class="mb-4">
                <label>Email Lists:</label>
                <treeselect v-model="user.emailLists" placeholder="Select Email List"
                            :options="emailLists"
                            :load-options="loadEmailLists"
                            :multiple="true"
                            value-format="object"/>
            </div>

            <div class="row" v-show="$route.params.id">
                <div class="reset-password-accordion" :class="{ 'opened' : create === true}">
                    <div @click="create = !create" class="reset-password-btn">
                        Change password
                    </div>
                </div>
            </div>
            <div v-show="create">
                <div class="form-group">
                    <label class="control-label">New Password</label>
                    <input type="password" id="password" name="password" v-model="user.password"
                           class="form-control"
                           placeholder="password">
                    <div v-if="$v.user.password.$error">
                        <div class="text-danger" v-if="!$v.user.password.required" v-show="!$route.params.id">
                            Password is required.
                        </div>
                        <div class="text-danger" v-if="!$v.user.password.minLength">
                            Password must have at least {{$v.user.password.$params.minLength.min }} letters.
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label class="control-label">Confirm New Password</label>
                    <input type="password" id="confirm_password" name="confirm_password"
                           v-model.trim="user.confirmPassword"
                           class="form-control"
                           placeholder="password">
                    <div v-if="$v.user.confirmPassword.$error">
                        <div class="text-danger" v-if="!$v.user.confirmPassword.required"
                             v-show="!$route.params.id">
                            Confirm Password is required.
                        </div>
                        <div class="text-danger" v-if="!$v.user.confirmPassword.sameAsPassword">
                            Passwords must be identical.
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-actions text-center">
            <button class="btn btn-info btn-rounded text-uppercase" v-show="!submitProcess">
                Save
            </button>
            <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light" disabled
                    v-show="submitProcess">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Submitting...
            </button>
            <router-link :to="{ name: 'users' }" class="btn btn-success btn-rounded text-uppercase m-l-5">
                Back
            </router-link>
        </div>
    </form>
</template>

<script>
    import {required, minLength, email, sameAs, between} from 'vuelidate/lib/validators';
    import UserService from '../../services/UserService';
    import Treeselect from '@riophae/vue-treeselect';
    import EmailListService from '../../services/EmailListService';

    export default {
        name: 'UserForm',
        components: {
            Treeselect
        },
        data() {
            return {
                user: {
                    username: null,
                    email: null,
                    password: null,
                    confirmPassword: null,
                    isActive: false,
                    emailLists: [],
                    profitRate: 100
                },
                emailLists: null,
                errors: {},
                submitProcess: false,
                create: true,
            }
        },
        mounted() {
            if (this.$route.params.id) {
                this.create = false;
                UserService.getUser(this.$route.params.id).then(response => {
                    this.user = response.data;
                    this.$emit('hidePreloader', false)
                });
            }
        },
        validations() {
            if (this.$route.params.id) {
                return {
                    user: {
                        username: {required},
                        email: {required, email},
                        password: {minLength: minLength(0)},
                        confirmPassword: {sameAs: sameAs('password')},
                        profitRate: {required, between: between(0, 100)}
                    }
                }
            } else {
                return {
                    user: {
                        username: {required},
                        email: {required, email},
                        password: {required, minLength: minLength(8)},
                        confirmPassword: {required, sameAs: sameAs('password')},
                        profitRate: {required, between: between(0, 100)}
                    }
                }
            }
        },
        methods: {
            loadEmailLists({callback}) {
                EmailListService.getEmailLists().then(response => {
                    this.emailLists = response.data.items.map(emailList => {
                        return {id: emailList.id, label: emailList.name}
                    });
                    callback();
                });
            },
            onSubmit() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                this.submitProcess = true;

                let submitMethod = null;
                if (this.$route.params.id) {
                    submitMethod = UserService.updateUser(this.$route.params.id, JSON.stringify(this.user));
                } else {
                    submitMethod = UserService.createUser(JSON.stringify(this.user));
                }
                submitMethod.then(response => {
                    this.submitProcess = false;
                    if (response.data.error !== undefined) {
                        this.errors = response.data.error;
                    } else {
                        this.$router.push({name: 'users'});
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>
